import { tabbable } from 'tabbable'

const lightboxBtns = Array.from(
    document.querySelectorAll('.grid__button-video-overlay'))

const onLightboxToggle = (lightbox) => {
    if (!lightbox)
        return

    const isActive = !lightbox.classList.contains('active')

    const iframeWrapper = lightbox
        .querySelector('.grid-lightbox__iframe[data-src]')

    if (iframeWrapper && isActive) {
        const src = iframeWrapper.getAttribute('data-src')
        const allowAttr = 'autoplay; clipboard-write; encrypted-media; picture-in-picture'

        iframeWrapper.innerHTML = `<iframe src="${src}" allow="${
            allowAttr}" allowfullscreen></iframe>`
    }

    if (isActive) {
        let parentEl = lightbox.parentElement

        while (parentEl !== document.documentElement) {
            Array.from(parentEl.children)
                .filter(el => lightbox !== el
                    && !el.contains(lightbox)
                    && !el.tagName.match(/^(script|styles)$/i)
                    && el.getAttribute('aria-hidden') !== 'true')
                .forEach((el) => {
                    el.setAttribute('data-aria-hidden-reset', true)
                    el.setAttribute('aria-hidden', true)
                    el.setAttribute('inert', true)
                })

            parentEl = parentEl.parentElement
        }
    }

    document.documentElement
        .classList[isActive ? 'add' : 'remove']('scroll-disabled')

    lightbox
        .classList[isActive ? 'add' : 'remove']('active')

    if (!isActive)
        Array.from(document
            .querySelectorAll('[data-aria-hidden-reset]'))
            .forEach((el) => {
                el.removeAttribute('data-aria-hidden-reset')
                el.removeAttribute('aria-hidden')
                el.removeAttribute('inert')
            })

    const focusEl = isActive
        ? (tabbable(lightbox) || [])[0]
        : (lightboxBtns.indexOf(lightbox.previousElementSibling) >= 0
            ? lightbox.previousElementSibling
            : null)

    if (focusEl)
        focusEl.focus()

    if (iframeWrapper && !isActive)
        iframeWrapper.innerHTML = ''
}

lightboxBtns
    .forEach((btn) => {
        const lightbox = btn.nextElementSibling.classList
            .contains('grid-lightbox__wrapper')
            ? btn.nextElementSibling
            : null

        if (!lightbox)
            return

        btn.addEventListener('click',
            (e) => onLightboxToggle(lightbox))

        const lightboxBtnClose = lightbox
            .querySelector('.grid-lightbox__button-close')

        if (lightboxBtnClose)
            lightboxBtnClose
                .addEventListener('click', (e) => {
                    e.preventDefault()
                    e.stopPropagation()

                    onLightboxToggle(lightbox)
                })

        lightbox.addEventListener('click',
            (e) => onLightboxToggle(lightbox))
    })

document
    .addEventListener('keydown', (e) => {
        const key = (e.key || e.keyIdentifier || '')

        const lightbox = document.body
            .querySelector('.grid-lightbox__wrapper.active')

        if (!lightbox)
            return

        if (key.match(/(escape)/i))
            return onLightboxToggle(lightbox)

        if (!key.match(/tab/i))
            return

        let focusEl

        const els = (tabbable(lightbox) || [])

        if (e.shiftKey
                && els.indexOf(e.target) === 0)
            focusEl = els[els.length - 1]

        if (!e.shiftKey
                && els.indexOf(e.target) === els.length - 1)
            focusEl = els[0]

        if (!focusEl)
            return

        e.preventDefault()
        e.stopPropagation()

        focusEl.focus()
    })
